import React from "react";
import CourseProgramCards from "../../Home/CourseProgramCards";

const ElectronicsTelecommunicationsPrograms = [
  {
    id: 1,
    image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?auto=format&fit=crop&w=2072&q=80",
    heading: "Electronic Circuits",
    introduction: "Learn analog and digital electronic circuit design.",
    buttonText: "LEARN MORE",
    route: "electronic-circuits",
  },
  {
    id: 2,
    image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?auto=format&fit=crop&w=2072&q=80",
    heading: "Communication Systems",
    introduction: "Understand wireless and wired communication technologies.",
    buttonText: "LEARN MORE",
    route: "communication-systems",
  },
  {
    id: 3,
    image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?auto=format&fit=crop&w=2072&q=80",
    heading: "Signal Processing",
    introduction: "Process and analyze electronic signals and data.",
    buttonText: "LEARN MORE",
    route: "signal-processing",
  },
  {
    id: 4,
    image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?auto=format&fit=crop&w=2072&q=80",
    heading: "Telecommunications Networks",
    introduction: "Design and manage telecommunications infrastructure.",
    buttonText: "LEARN MORE",
    route: "telecommunications-networks",
  },
  {
    id: 5,
    image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?auto=format&fit=crop&w=2072&q=80",
    heading: "Mobile Communications",
    introduction: "Learn mobile network technologies and protocols.",
    buttonText: "LEARN MORE",
    route: "mobile-communications",
  },
  {
    id: 6,
    image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?auto=format&fit=crop&w=2072&q=80",
    heading: "Satellite Communications",
    introduction: "Understand satellite communication systems and technology.",
    buttonText: "LEARN MORE",
    route: "satellite-communications",
  },
];

const ElectronicsTelecommunicationsProgramsCard = () => {
  return (
    <div className="flex justify-center space-x-0">
      <CourseProgramCards
        programs={ElectronicsTelecommunicationsPrograms}
        basePath="/courses/electronics-telecommunications"
      />
    </div>
  );
};

export default ElectronicsTelecommunicationsProgramsCard;
